import request from "../utils/request";

// ─── 类型定义 ─────────────────────────────────────────────────────────────────

export interface RateWithDailyTrend {
  rate: string;
  dailyDates: string[];
  dailyRates: string[];
  totalUsers: string;
  eligibleUsers: string;
  qualifiedUsers: string;
  total: string;
  useful: string;
  useless: string;
}

export interface PenetrationActiveRate extends RateWithDailyTrend {
  currentWeek: string;
}

export interface WeeklyTrend {
  weekEndDates: string[];
  activeUserRates: string[];
  highEngagementRates: string[];
}

export interface PenetrationResponse {
  activeUserRate: PenetrationActiveRate;
  highEngagementRate: PenetrationActiveRate;
  weeklyTrend: WeeklyTrend;
}

export interface UserSatisfaction {
  rate: string;
  usefulCount: string;
  uselessCount: string;
  noFeedbackCount: string;
}

export interface FeedbackReason {
  reason: string;
  count: string;
}

export interface QualityResponse {
  usefulAnswerRate: RateWithDailyTrend;
  uselessAnswerRate: RateWithDailyTrend;
  userSatisfaction: UserSatisfaction;
  responseTime: {
    shortTermGoal: { p75DurationMs: number; targetMs: number; met: boolean };
    longTermGoal: { p95DurationMs: number; targetMs: number; met: boolean };
  };
  uselessFeedbackReasons: FeedbackReason[];
}

export interface QualityParams {
  startTime?: string;
  endTime?: string;
}

export interface AnswerTrendPoint {
  date: string;
  answerCount: number;
  userCount: number;
}

export interface AnswerTrendResponse {
  totalAnswerCount: number;
  totalUserCount: number;
  startDate: string;
  endDate: string;
  daily: AnswerTrendPoint[];
}

export interface AnswerTrendParams {
  startTime?: string;
  endTime?: string;
}

// ─── 工具函数 ─────────────────────────────────────────────────────────────────

/**
 * PascalCase 字符串 → 句子格式（首字母大写，其余小写）
 * 例：AnswerIncorrectOrHasErrors → Answer incorrect or has errors
 */
export function parsePascalCaseReason(reason: string): string {
  const words = reason.replace(/([A-Z])/g, " $1").trim();
  return words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
}

// ─── API 方法 ─────────────────────────────────────────────────────────────────

export async function getPenetration(params?: AnswerTrendParams): Promise<PenetrationResponse> {
  const res = await request.get<PenetrationResponse>("/project/analytics/penetration", { params });
  return res.data;
}

export async function getQuality(params?: QualityParams): Promise<QualityResponse> {
  const res = await request.get<QualityResponse>("/project/analytics/quality", { params });
  return res.data;
}

export async function getAnswerTrend(params?: AnswerTrendParams): Promise<AnswerTrendResponse> {
  const res = await request.get<AnswerTrendResponse>("/project/analytics/trend", { params });
  return res.data;
}
